import { render } from "./SuccessBanner.vue?vue&type=template&id=4a237d86"
import script from "./SuccessBanner.vue?vue&type=script&lang=js"
export * from "./SuccessBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__